/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsdescription1Inputs */

const en_groupsdescription1 = /** @type {(inputs: Groupsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to your guests under your own name. They are in the app and can get tickets right in the chat.`)
};

const de_groupsdescription1 = /** @type {(inputs: Groupsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib deinen Gästen direkt unter deinem Namen. Sie sind in der App dabei und können Tickets gleich im Chat holen.`)
};

/**
* | output |
* | --- |
* | "Write to your guests under your own name. They are in the app and can get tickets right in the chat." |
*
* @param {Groupsdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsdescription1 = /** @type {((inputs?: Groupsdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsdescription1(inputs)
	return de_groupsdescription1(inputs)
});
export { groupsdescription1 as "groupsDescription" }